




import Vue from 'vue'
import { Chat } from '@/components/Widgets'
import { ChatWidget } from '@/types/chatwidget'

export default Vue.extend({
  name: 'ChatWidget',
  computed: {
    widgetId (): string {
      return this.$route.params.id
    },
    chat (): ChatWidget {
      return this.$store.direct.state.chatwidget.widget
    }
  },
  watch: {
    'chat.cast_id' (newVal: string) {
      this.$store.direct.dispatch.events.subscribeCurrentCast(newVal)
    },
    'chat.team_id' (newVal: string) {
      this.$store.direct.dispatch.events.getCastTeam(newVal)
    }
  },
  mounted () {
    this.$store.direct.dispatch.chatwidget.subscribe(this.widgetId)
  },
  beforeDestroy () {
    this.$store.direct.dispatch.chatwidget.unsubscribe(this.widgetId)
    this.$store.direct.dispatch.events.unsubscribeCastTeam(this.chat.team_id)
  },
  components: {
    Chat
  }
})
